"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Save;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Save(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    id: "General"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "save"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "outline-4",
    "data-name": "outline"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M91.768,25.443,74.556,8.232A2.5,2.5,0,0,0,72.788,7.5H10A2.5,2.5,0,0,0,7.5,10V90A2.5,2.5,0,0,0,10,92.5H90A2.5,2.5,0,0,0,92.5,90V27.211A2.5,2.5,0,0,0,91.768,25.443ZM61.167,12.5V29.3H24.176V12.5ZM87.5,87.5h-75v-75h6.676V31.8a2.5,2.5,0,0,0,2.5,2.5H63.667a2.5,2.5,0,0,0,2.5-2.5V12.5h5.586L87.5,28.246Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M50,41.435A19.806,19.806,0,1,0,69.807,61.24,19.828,19.828,0,0,0,50,41.435Zm0,34.612A14.806,14.806,0,1,1,64.807,61.24,14.825,14.825,0,0,1,50,76.047Z"
  })))));
}